import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { useState } from 'react';
import moment from 'moment';

import ThresholdSettingsWithPeriod from '../thresholdSettingsWithPeriod';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  submitInProgress: boolean,
  timeStamp: number,
  onDataChanged: (data: WorldSettings) => void
}

export function LowPowerEventSettings(props: IProps) {
  const { t } = useTranslation('settings');
  const [alertTimeStamp, setAlertTimeStamp] = useState<number>(props.timeStamp);

  if (props.timeStamp > alertTimeStamp) {
    setAlertTimeStamp(props.timeStamp);
  }

  function onDataChanged(data: number, field?: string) {
    if (field === 'warning') {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceLowPowerYellow: data });
    } else if (field === 'problem') {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceLowPowerRed: data });
    } else {
      props.onDataChanged({ ...props.worldSettings, deviceUserExperienceLowPowerPeriod: data });
    }
  }

  function onAlertToggled(data: boolean, initialSettings: { warning: number, problem: number, days: number }) {
    setAlertTimeStamp(moment.utc().valueOf());
    props.onDataChanged({
      ...props.worldSettings,
      deviceUserExperienceLowPowerEnabled: data,
      deviceUserExperienceLowPowerYellow: initialSettings.warning,
      deviceUserExperienceLowPowerRed: initialSettings.problem,
      deviceUserExperienceLowPowerPeriod: initialSettings.days
    });
  }

  return (
    <ThresholdSettingsWithPeriod
      key={alertTimeStamp}
      title={t('LOW_POWER_EVENTS_TITLE')}
      message={'LOW_POWER_EVENTS_MESSAGE'}
      popoverText={t('LOW_POWER_EVENTS_POPOVER')}
      className="low-power-events"
      days={props.worldSettings.deviceUserExperienceLowPowerPeriod}
      warning={props.worldSettings.deviceUserExperienceLowPowerYellow}
      problem={props.worldSettings.deviceUserExperienceLowPowerRed}
      dataUpdated={onDataChanged}
      disabled={props.submitInProgress || !props.worldSettings.deviceUserExperienceLowPowerEnabled}
      alertEnabled={props.worldSettings.deviceUserExperienceLowPowerEnabled}
      alertToggled={onAlertToggled}
    />
  );
}
